<template>
  <br />
  <span class="text_4">通过对您的调研采集的信息，参考国内顶级专家顾问建议，对您的心脏风险初步评估如下：</span>
  <br />
  <br />
  <van-rate v-model="starValue" :size="25" color="#ffd21e" void-icon="star" void-color="#eee" allow-half readonly />
  <van-divider :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }">
    具体分析
  </van-divider>
  <p class="text3Indentation"><van-card title="年龄因素" :thumb="require('./assets/img/age.jpg')">
      <template #desc>
        <div>
          <p class="textIndentation">年龄是冠心病的重要危险因素。我国人常于40岁以后发病，平均年龄46.6岁.美国统计：每增加10岁，心脏病病死率几乎增加1倍。</p>
        </div>
      </template>
      <template #tags>
        <van-tag plain :type="ageType">{{ ageDesc }}</van-tag>
      </template>
    </van-card>
  </p>
  <p class="text3Indentation">
    <van-card title="体脂风险" :thumb="require('./assets/img/tizhong.jpg')">
      <template #desc>
        <div>
          <p class="textIndentation">您的体脂率为{{ PersonBaseRisk.bodyBmi }}，正常水平18.5~24。多数先发生肥胖，7-8年后发生冠心病。</p>
        </div>
      </template>
      <template #tags>
        <van-tag plain :type="bmiType">{{ bmiDesc }}</van-tag>
      </template>
    </van-card>
  </p>
  <p class="text3Indentation"><van-card title="家族病史"
      :thumb="require('./assets/img/jiazhubing.jpg')">
      <template #desc>
        <div>
          <p class="textIndentation">冠心病发病具有明显的家族性。父母之一是冠心病患者，其子女患病率为双亲正常的子女的2倍。</p>
        </div>
      </template>
      <template #tags>
        <van-tag plain :type="familialType">{{ familialDiseaseDesc }}</van-tag>
      </template>
    </van-card>
  </p>
  <p class="text3Indentation"><van-card title="性格因素" :thumb="require('./assets/img/qingxu.jpg')">
      <template #desc>
        <div>
          <p class="textIndentation">A类性格为快步调的、急躁的、侵略性的、竞争性的。B类性格为轻松的、容易相处、懒散的。根据跟踪发现，患病人群中70.9%为A类性格。</p>
        </div>
      </template>
      <template #tags>
        <van-tag plain :type="xingGeType">{{ xingGeDesc }}</van-tag>
      </template>
    </van-card>
  </p>
  <p class="text3Indentation"><van-card title="性别因素" :thumb="require('./assets/img/xingbie.jpg')">
      <template #desc>
        <div>
          <p class="textIndentation">患病率一般是男性高于女性，男女比例为2～5:1，这种差别主要发生在50岁之前。50岁之后，女性发病率明显上升甚至赶上男性。</p>
        </div>
      </template>
      <template #tags>
        <van-tag plain :type="genderType">{{ genderDesc }}</van-tag>
      </template>
    </van-card>
  </p>
  <p class="text3Indentation"><van-card title="吸烟风险" :thumb="require('./assets/img/xiyan.jpg')">
      <template #desc>
        <div>
          <p class="textIndentation">吸烟者比不吸烟的冠心病发病率高出2.6倍，戒烟后冠心病的发病率可以减少50%。吸烟已经被确认是独立危险因素，尤其是每日吸烟超过10支以上者。</p>
        </div>
      </template>
      <template #tags>
        <van-tag plain :type="smokingType">{{ smokingDesc }}</van-tag>
      </template>
    </van-card>
  </p>
  <p class="text3Indentation"><van-card title="血糖风险"
      :thumb="require('./assets/img/xuetang.png')">
      <template #desc>
        <div>
          <p class="textIndentation">资料证明，糖尿病患者中，合并冠心病者男性达40%，女性则达65%，血糖增高者心肌梗死的发病率2倍于血糖正常者。</p>
        </div>
      </template>
      <template #tags>
        <van-tag plain :type="diabetesType">{{ diabetesDesc }}</van-tag>
      </template>
    </van-card>
  </p>
  <p class="text3Indentation"><van-card title="血压风险" :thumb="require('./assets/img/xueya.png')">
      <template #desc>
        <div>
          <p class="textIndentation">我国的流行病学调查资料证实，高血压组合并冠心病者较血压正常组高2～4倍，我国患者70%以上合并高血压。</p>
        </div>
      </template>
      <template #tags>
        <van-tag plain :type="xueYaType">{{ xueYaDesc }}</van-tag>
      </template>
    </van-card>
  </p>
  <p class="text3Indentation"><van-card title="血脂风险" :thumb="require('./assets/img/xuezhi.jpeg')">
      <template #desc>
        <div>
          <p class="textIndentation">临床实践证明，总胆固醇或低密度脂蛋白胆固醇水平降低1%，冠心病死亡危险减少2%。</p>
        </div>
      </template>
      <template #tags>
        <van-tag plain :type="xueZhiType">{{ xueZhiDesc }}</van-tag>
      </template>
    </van-card>
  </p>
  <br/>
  <van-button round color="linear-gradient(to right, #f67f34, #d55809)" size="large" to="preProjectAd">体检套餐建议</van-button>
</template>
<script>
import { ref, toRefs, reactive, onMounted } from 'vue';
import { getBaseRisk } from '../../api/cardiovascular'
import { postUserLog } from '../../api/userlog'
import { useRouter } from 'vue-router';
export default {
  setup() {
  const router = useRouter(); 
   const ulog = reactive({
      UserLog: {
        path: '',
      }
    })
    const starValue = ref();
    const familialDiseaseDesc = ref();
    const diabetesDesc = ref();
    const smokingDesc = ref();
    const diabetesType = ref();
    const smokingType = ref();
    const familialType = ref();
    const bmiDesc = ref();
    const bmiType = ref();
    const genderDesc = ref();
    const genderType = ref();
    const xueYaDesc = ref();
    const xueYaType = ref();
    const xueZhiDesc = ref();
    const xueZhiType = ref();
    const xingGeDesc = ref();
    const xingGeType = ref();
    const ageDesc = ref();
    const ageType = ref();
    const state = reactive({
      PersonBaseRisk: {
        personId: '',
        baseRiskLevel: '',
        isAge: '',
        bodyBmi: '',
        isSmoking: '',
        isDiabetes: '',
        isBodyBmi: '',
        isFamilialDisease: '',
        isGender: '',
        isXueYa: '',
        isXueZhi: '',
        isXingGe: '',
      }
    })
    onMounted(() => {
      console.log('页面打开')
      ulog.UserLog.path = router.currentRoute.value.fullPath;
        console.log("当前页面路径=="+ulog.UserLog.path) 
        postUserLog(ulog.UserLog).then(() => {
         
        })
     
      getBaseRisk().then((res) => {
        state.PersonBaseRisk = res.data.data;
        console.log(state.PersonBaseRisk);
        starValue.value = state.PersonBaseRisk.baseRiskLevel;
        if (state.PersonBaseRisk.isBodyBmi == 1) {
          bmiDesc.value = "有一定风险";
          bmiType.value = "danger"
        } else {
          bmiDesc.value = "无明显风险";
          bmiType.value = "success"
        }
        if (state.PersonBaseRisk.isSmoking == 1) {
          smokingDesc.value = "有一定风险";
          smokingType.value = "danger"
        } else {
          smokingDesc.value = "无明显风险";
          smokingType.value = "success"
        }
        if (state.PersonBaseRisk.isDiabetes == 1) {
          diabetesDesc.value = "有一定风险";
          diabetesType.value = "danger"
        } else {
          diabetesDesc.value = "无明显风险";
          diabetesType.value = "success"
        }
        if (state.PersonBaseRisk.isFamilialDisease == 1) {
          familialDiseaseDesc.value = "有一定风险";
          familialType.value = "danger"
        } else {
          familialDiseaseDesc.value = "无明显风险";
          familialType.value = "success"
        }
        if (state.PersonBaseRisk.isFamilialDisease == 1) {
          familialDiseaseDesc.value = "有一定风险";
          familialType.value = "danger"
        } else {
          familialDiseaseDesc.value = "无明显风险";
          familialType.value = "success"
        }
        if (state.PersonBaseRisk.isGender == 1) {
          genderDesc.value = "有一定风险";
          genderType.value = "danger"
        } else {
          genderDesc.value = "无明显风险";
          genderType.value = "success"
        }
        if (state.PersonBaseRisk.isXueYa == 1) {
          xueYaDesc.value = "有一定风险";
          xueYaType.value = "danger"
        } else {
          xueYaDesc.value = "无明显风险";
          xueYaType.value = "success"
        }
        if (state.PersonBaseRisk.isXueZhi == 1) {
          xueZhiDesc.value = "有一定风险";
          xueZhiType.value = "danger"
        } else {
          xueZhiDesc.value = "无明显风险";
          xueZhiType.value = "success"
        }
        if (state.PersonBaseRisk.isXingGe == 1) {
          xingGeDesc.value = "有一定风险";
          xingGeType.value = "danger"
        } else {
          xingGeDesc.value = "无明显风险";
          xingGeType.value = "success"
        }
        if (state.PersonBaseRisk.isAge == 1) {
          ageDesc.value = "有一定风险";
          ageType.value = "danger"
        } else {
          ageDesc.value = "无明显风险";
          ageType.value = "success"
        }
      })
    })
    return {
      starValue,
      diabetesType,
      smokingType,
      familialType,
      bmiType,
      bmiDesc,
      diabetesDesc,
      smokingDesc,
      familialDiseaseDesc,
      genderDesc,
      genderType,
      xueYaDesc,
      xueYaType,
      xueZhiDesc,
      xueZhiType,
      xingGeDesc,
      xingGeType,
      ageDesc,
      ageType,
      ...toRefs(state),
    };
  },
};
</script>

<style scoped lang="css" src="./assets/basic_index.css" />
  